<script>
export default {
  name: 'TwDate',
  props: {
    modelValue: {
      type: [String,Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    smallLabel: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(7)
    },
    required: {
      type: Boolean,
      default: false
    },
    prepend: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'update'],
}
</script>

<template>
  <div class="w-full">
    <label v-if="label" :for="id" class="form-label"> {{ label }} </label>
    <div v-if="smallLabel || $slots.smallLabel" class="form-label-sm">
      <slot name="smallLabel">
        {{ smallLabel }}
      </slot>
    </div>
    <span v-if="disabled" class="font-forms font-semibold"> {{ modelValue? $filters.formatDateOnly(modelValue):null }} </span>
    <input
      v-else :id="id"
      ref="input" :disabled="disabled" :required="required" :value="modelValue" type="date" :name="id" :autocomplete="id"
      class="block w-full rounded-md border-0 py-2 min-h-[44px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-gray-800  sm:leading-6"
      :placeholder="placeholder" @input="$emit('update:modelValue', $event.target.value)"
    >
  </div>
</template>

<style scoped>

</style>
